import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const jiraServiceManagement = defineConnector({
  identifier: "jiraServiceManagement",
  name: "Jira Service Management",
  tagLine: "IT service management and help desk",
  keywords:
    "atlassian jsm jira service desk itsm tickets requests incidents approvals sla customers",
  logo,
  protocol: "http",
  tags: ["it", "productivity"],
  defaultUrlPattern: () =>
    "https://([^/]*\\.atlassian\\.net/rest/(api|servicedeskapi)|api\\.atlassian\\.com/jsm/assets)/.*",
  auth: (app) =>
    basicAuth({
      username: app.config.email,
      password: app.secret.apiToken,
    }),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Visit [this page](https://id.atlassian.com/manage-profile/security/api-tokens) signed in as the account you’d like associated with your automated Jira Service Management actions. (We recommend a service account with agent access to your service projects.)\n\nClick **Create API token** and give it a label when asked.",
        },
      ],
    },
    {
      title: "Copy and paste the API token here",
      items: [
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
    {
      title: "Enter the account’s email address",
      items: [
        {
          kind: "input",
          label: "API token account email",
          placeholder: "you@example.com",
          required: true,
          target: { kind: "configuration", field: "email" },
        },
      ],
    },
    {
      title: "Enter your Jira Service Management account domain",
      items: [
        {
          kind: "hostname",
          label: "Jira Service Management account domain",
          placeholder: "example.atlassian.net",
          required: true,
          target: { kind: "configuration", field: "domain" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) =>
      `https://${domain}/rest/servicedeskapi/servicedesk`,
  },
  publicEnvVars: ({ domain, email }) => ({
    JIRA_SERVICE_MANAGEMENT_DOMAIN: domain || "",
    JIRA_SERVICE_MANAGEMENT_EMAIL: email || "",
  }),
});
